<!-- Show skeleton loader while loading -->
<app-product-detail-skeleton *ngIf="isLoadingProduct"></app-product-detail-skeleton>

<!-- Show actual product when loaded -->
<div class="container" *ngIf="!isLoadingProduct">
  <!-- <div class="row">
    <div class="col-12">
      <button (click)="goBack()" class="btn btn-outline-secondary">
        <span>{{ t('back') }}</span>
      </button>
    </div>
  </div> -->
  <div *ngIf="product" class="product-detail" [class]="'dose-' + product.doseType">
    <!-- [ngStyle]="doseColorService.generateGradientStyle(product.doseType)" -->

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="product-image-section carousel-wrapper" *ngIf="getImageArray()?.length">
          <div class="carousel-track" [style.transform]="'translateX(-' + currentImageIndex * 100 + '%)'">
            <div class="carousel-image" *ngFor="let img of getImageArray()">
              <img [src]="getImageUrl(img)" [alt]="getLocalizedName()" class="product-main-image" (error)="onImageError($event)" />
            </div>
          </div>
          <div class="carousel-dots">
            <span class="dot" *ngFor="let img of getImageArray(); let i = index" [class.active]="i === currentImageIndex"
              (click)="goToImage(i)">
            </span>
          </div>
        </div>

      </div>
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-12">
            <h1 class="product-main-title" [ngStyle]="{color : doseColorService.getDosePrimaryColor(product.doseType)}">
              {{ getLocalizedName() }}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="product-info-section">
              <p class="benefit-text">{{ getLocalizedDescription() }}</p>
            </div>
          </div>

          <div class="col-12">
            <div class="product-right" *ngIf="currentUser">
              <!-- Quantity Options -->
              <div class="quantity-options-section">
                <div class="quantity-options">
                  <div class="quantity-option" *ngFor="let dose of totalProducts; let i = index"
                    [title]="i < currentUser.takenDose ? t('alreadyTakenDose'): i === currentUser.takenDose ?  t('curruntDose') : t('upcomingDose')"
                    [class.taken]="i < currentUser.takenDose" [class.current]="i === currentUser.takenDose"
                    [ngStyle]="doseColorService.generateDoseForCountStyles(dose.doseType,i <= currentUser.takenDose)">
                    <div class="quantity-badge">{{i + 1}}</div>
                  </div>
                </div>
              </div>

              <!-- Overview Text -->
              <div class="overview-text">
                <p class="overview-title">{{ t('yourDoseIsDone', {dose: currentUser.takenDose.toString()}) }}</p>
              </div>
            </div>
          </div>

          <!-- Features and Benefits - Next to image -->
          <div class="col-12" *ngIf="getLocalizedFeatures()?.length">
            <div class="product-description-section">
              <h4 class="section-label">{{ t('features') }}:</h4>
              <ul class="description-list">
                <li class="description-item" *ngFor="let feature of getLocalizedFeatures()">
                  {{ feature }}
                </li>
              </ul>
            </div>
          </div>
          <div class="col-12" *ngIf="getLocalizedBenefits()?.length">
            <div class="product-description-section">
              <h4 class="section-label">{{ t('benefits') }}:</h4>
              <ul class="description-list">
                <li class="description-item" *ngFor="let benefits of getLocalizedBenefits()">
                  {{ benefits }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Category Selection Cards - Below Image, Full Width -->
    <div class="row">
      <div class="col-12">
        <div class="category-selection-section" *ngIf="categories.length > 0">
          <h5 class="category-section-title">{{ t('selectCategory') || 'Select Category' }}</h5>
          <div class="category-cards-container">
            <div 
              class="category-card" 
              *ngFor="let category of categories"
              [class.selected]="isCategorySelected(category)"
              (click)="selectCategory(category)">

              <div 
                class="category-recommended-ribbon"
                *ngIf="currentUser && isCategoryRecommended(category)"
                [title]="t('recommendedTooltip') || 'As per your age, this product is recommended by experts'">
                {{ t('recommended') || 'Recommended' }}
              </div>

              <div class="category-card-header">
                <div class="category-name">{{ getLocalizedCategoryName(category) }}</div>
                <div class="category-card-check">
                  <!-- <i class="fas fa-check-circle" *ngIf="isCategorySelected(category)"></i> -->
                </div>
              </div>
              
              <!-- Sub-Product Options -->
              <div class="sub-product-options-container" *ngIf="getSubProductsArray(category).length > 0">
                <div 
                  class="sub-product-option" 
                  *ngFor="let subProduct of getSubProductsArray(category); let i = index"
                  [class.selected]="isSubProductOptionSelected(category, i)">
                  <div class="sub-product-header">
                    <div class="sub-product-label">
                      {{ getOptionLabel(i) }}
                    </div>
                    <button 
                      type="button"
                      class="btn btn-select-sub-product"
                      [class.selected]="isSubProductOptionSelected(category, i)"
                      (click)="selectSubProductOption(category, i, $event)">
                      <i class="fas fa-check" *ngIf="isSubProductOptionSelected(category, i)"></i>
                      <span *ngIf="!isSubProductOptionSelected(category, i)">{{ t('select') || 'Select' }}</span>
                      <span *ngIf="isSubProductOptionSelected(category, i)">{{ t('selected') || 'Selected' }}</span>
                    </button>
                  </div>
                  <div class="sub-product-content">
                    <div class="sub-product-text">{{ subProduct }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Price and Buy Now Button - Below Category Selection (sticky-on-scroll row) -->
    <div class="row product-actions-sticky-row">
      <div class="col-12">
        <div class="product-actions">
          <div class="price-and-quantity">
            <div class="final-price">
              @if (selectedCategory) {
                <span class="price-value">₹{{getCurrentPrice() | number:'1.2-2'}}</span>
                @if (getOriginalPrice()) {
                  <span class="og-price">₹{{getOriginalPrice() | number:'1.2-2'}}</span>
                  <span class="disscount">({{getDiscountPercentage(getCurrentPrice(), getOriginalPrice() || 0)}}% OFF)</span>
                }
              } @else if (product.price) {
                <span class="price-value">₹{{product.price | number:'1.2-2'}}</span>
                @if (product.originalPrice) {
                  <span class="og-price">₹{{product.originalPrice | number:'1.2-2'}}</span>
                  <span class="disscount">({{getDiscountPercentage(product.price, product.originalPrice)}}% OFF)</span>
                }
              } @else {
                <span class="price-value text-muted">{{ t('selectCategoryToSeePrice') || 'Select a category to see price' }}</span>
              }
            </div>

            <!-- <div class="quantity-selector">
        <button (click)="decreaseQuantity()" class="quantity-btn">−</button>
        <span class="quantity-display">{{selectedQuantity}}</span>
        <button (click)="increaseQuantity()" class="quantity-btn">+</button>
      </div> -->
          </div>

          <!-- Buy Now Button -->
          <button (click)="buyNow()" class="btn btn-primary">
            <i class="fas fa-shopping-cart me-2"></i>
            {{ t('buyNow') }}
          </button>
        </div>
      </div>
    </div>


  </div>
</div>
